import { client } from '../../../actions';

const getConsentText = async () => {
  try {
    const response = await client.get('/TwoFactAuth/get_consent_text');
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export default getConsentText;
